import { render, staticRenderFns } from "./UOMHelpList.vue?vue&type=template&id=5b190fc1&"
import script from "./UOMHelpList.vue?vue&type=script&lang=js&"
export * from "./UOMHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports